import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import TableDesign from "../../common/table/TableDesign";
import AlertModal from "./AlertModal";
import useAlertModal from "./useAlertModal";
import styles from "./ScheduleWiseReportList.module.css";
import download from "../../../assets/images/download.png";
import Loader from "../../common/loader/Loader";

const ScheduleWiseReportList = ({ selectedDate, downloadType }) => {
  const {
    reports,
    downloadCombineFileOfDate,
    isDownloadLoader,
    downloadFileOfCurrentDate,
    downloadFileOfDate,
    downloadAllFilesOfDate,
    downloadFileOfDateCsv,
    downloadAllFilesOfDateCsv,
    pagination,
    error: apiError,
  } = useSelector((state) => {
    return state.reports;
  });

  const {
    modalConfig,
    hideAlert,
    showSuccess,
    showError,
    showInfo,
    showConfirm,
  } = useAlertModal();

  const tableHeadings = [
    { label: "Sr. No." },
    { label: "Date" },
    { label: "Time" },
    { label: "Action", align: "center" },
  ];

  console.log("selectedDate in ScheduleWiseReportList:", selectedDate);
  const handleSubmit = () => {
    // Handle submit logic here
    // You can dispatch an action to fetch reports based on selected date and time
    // dispatch(fetchReportsByDateTime({ date: selectedDate, time: selectedTime }));
  };

  const handleDownload = (reportId) => {
    // Handle individual report download
    console.log("Downloading report:", reportId);
    // You can dispatch an action to download specific report
    // dispatch(downloadReport(reportId));
  };

const handleDownloadAll = () => {
  if (downloadType === "xlsx") {
    if (!downloadAllFilesOfDate) {
      showError("No XLSX files available for download");
      return;
    }

    showConfirm(
      "Are you sure you want to download all XLSX reports?",
      () => {
        window.open(downloadAllFilesOfDate, "_blank");
        showSuccess("XLSX download started successfully!");
      },
      "Download All XLSX Reports"
    );
  }

  if (downloadType === "csv") {
    if (!downloadAllFilesOfDateCsv) {
      showError("No CSV files available for download");
      return;
    }

    showConfirm(
      "Are you sure you want to download all CSV reports?",
      () => {
        window.open(downloadAllFilesOfDateCsv, "_blank");
        showSuccess("CSV download started successfully!");
      },
      "Download All CSV Reports"
    );
  }
};


  const downloadCurerntFile = () => {
    // alert("download");
    window.open(
      downloadFileOfCurrentDate,
      "_blank" // <- This is what makes it open in a new window.
    );
    window.location.reload(true);
  };

  return (
    <>
      {isDownloadLoader && <Loader />}

      {/* Alert Modal */}
      <AlertModal {...modalConfig} onHide={hideAlert} />

      <div className={styles.datewiseReportContainer}>
        {/* Reports Table */}
        <div className={styles.reportsTableSection}>
          {/* Table using TableDesign component */}
          {downloadType === "xlsx" && downloadFileOfCurrentDate && (
            <TableDesign
              className="mt-3"
              {...{
                title: "List of Reports",
                tableHeadings,
                ...(!apiError &&
                  downloadFileOfDate?.length > 1 && {
                    button: {
                      label: "DOWNLOAD ALL",
                      action: handleDownloadAll,
                    },
                  }),
              }}
            >
              {!apiError &&
              downloadFileOfDate &&
              downloadFileOfDate.length > 0 ? (
                downloadFileOfDate.map((report, index) => (
                  <tr key={report.id}>
                    <td align="left">{index + 1}.</td>
                    <td align="left">{report?.date}</td>
                    <td align="left">{report.time}</td>
                    <td align="center">
                      {downloadFileOfDate && (
                        <a
                          className="btn btn-sm btn-success text-white"
                          href={report?.filePath}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={download} alt="img" /> Download
                        </a>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" align="center">
                    No reports available
                  </td>
                </tr>
              )}
            </TableDesign>
          )}
          {/* csv */}
           {downloadType === "csv" && downloadFileOfDateCsv && (
            <TableDesign
              className="mt-3"
              {...{
                title: "List of Reports",
                tableHeadings,
                ...(!apiError &&
                  downloadFileOfDateCsv?.length > 1 && {
                    button: {
                      label: "DOWNLOAD ALL",
                      action: handleDownloadAll,
                    },
                  }),
              }}
            >
              {!apiError &&
                downloadFileOfDateCsv &&
              downloadFileOfDateCsv.length > 0 ? (
                downloadFileOfDateCsv.map((report, index) => (
                  <tr key={report.id}>
                    <td align="left">{index + 1}.</td>
                    <td align="left">{report?.date}</td>
                    <td align="left">{report.time}</td>
                    <td align="center">
                      {downloadFileOfDateCsv && (
                        <a
                          className="btn btn-sm btn-success text-white"
                          href={report?.filePath}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={download} alt="img" /> Download
                        </a>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" align="center">
                    No reports available
                  </td>
                </tr>
              )}
            </TableDesign>
          )}
        </div>
      </div>
    </>
  );
};

export default ScheduleWiseReportList;
